import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/comms";
import deltas from "../../actions/deltas";

const {SET_COMMS_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.STATIC, SET_COMMS_STATE);
